import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi, useMicrositeContext } from "./MicrositeLayout";
import { Card, CardContent } from "../../components/ui/card";
import { Stethoscope, Loader2 } from "lucide-react";

export default function MicrositeDoctors() {
  const { clinic, slug, basePath } = useMicrositeContext();
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const primary = clinic.primary_color || "#2563EB";

  useEffect(() => {
    publicApi.get(`/public/clinic/${slug}/doctors`).then(({ data }) => setDoctors(data)).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div data-testid="microsite-doctors">
      <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Manrope" }}>Our doctors</h1>
      <p className="text-slate-500 mb-8">Pick a doctor and book directly from their profile.</p>
      {loading ? (
        <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
      ) : doctors.length === 0 ? (
        <div className="py-10 text-center text-slate-400">No doctors listed yet.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {doctors.map((d) => (
            <Card key={d.user_id} className="border-slate-200" data-testid={`microsite-doctor-${d.user_id}`}>
              <CardContent className="p-6">
                <div className="w-14 h-14 rounded-full flex items-center justify-center text-white font-bold text-xl mb-4" style={{ backgroundColor: primary }}>
                  {d.name.replace(/^dr\.?\s*/i, "")[0]?.toUpperCase() || "D"}
                </div>
                <div className="font-semibold text-slate-900 text-lg" style={{ fontFamily: "Manrope" }}>{d.name}</div>
                <div className="text-xs uppercase tracking-wide text-slate-400 mt-1 mb-4">{d.role}</div>
                <Link
                  to={`${basePath}/book?doctor=${d.user_id}`}
                  className="inline-flex items-center gap-2 text-sm font-medium hover:underline"
                  style={{ color: primary }}
                  data-testid={`microsite-doctor-book-${d.user_id}`}
                >
                  Book with {d.name.split(" ").slice(0, 2).join(" ")} →
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
